import React from 'react';
import { hasConsent } from '../../utils/BioBankUtil';
import Alert from '../Alert';
import { FormattedMessage } from 'react-intl';
import { Consent } from './print/Consent';
import { formatDate } from '../../utils/TimeUtils';
import Row from '../tag/Row';
import Span from '../tag/Span';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import OTIcon from '../tag/OTIcon';

const { id: module_id } = module;

export class ConsentDocument extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validationErrors: false,
      incidental: {
        original: null,
        value: null,
      },
      recontact: {
        original: null,
        value: null,
      },
    };
  }

  componentDidMount() {
    let { consentData, context } = this.props;
    if (hasConsent(consentData) && context === 'current') {
      let { incidental, recontact } = consentData;
      this.initChoices(incidental, recontact);
    }
    this.setState({
      clicked: false
    })
  }

  initChoices = (incidental, recontact) => {
    this.setState({
      incidental: {
        original: incidental,
        value: incidental,
      },
      recontact: {
        original: recontact,
        value: recontact,
      },
    });
  };

  setOption(key, value) {
    this.setState(
      {
        [key]: {
          original: this.state[key].original,
          value,
        },
      },
      () => {
        if (this.state.validationErrors) {
          // if error is on, validate again
          this.validate();
        }
      }
    );
  }

  validate = () => {
    let {
      incidental: { value: incidentalValue },
      recontact: { value: recontactValue },
    } = this.state;

    let isValid =
      (incidentalValue === 'YES' || incidentalValue === 'NO') &&
      (recontactValue === 'YES' || recontactValue === 'NO');

    this.setState({ validationErrors: !isValid });
    return isValid;
  };

  next = () => {
    let {
      next,
      documentContentData: { documentVersion },
    } = this.props;
    let {
      incidental: { value: incidentalValue },
      recontact: { value: recontactValue },
    } = this.state;

    if (this.validate()) {
      next(incidentalValue, recontactValue, documentVersion);
    }
  };

  renderErrors() {
    let { validationErrors } = this.state;

    return (
      <>
        {validationErrors && (
          <Alert message={`${module_id}.consent.selection.error`} />
        )}
      </>
    );
  }

  mapDocumentContentComponents = () => {
    let { documentContentData } = this.props;
    return documentContentData.content.reduce((acc, cur) => {
      if (cur.name === 'header') {
        return { ...acc, header: cur };
      } else if (cur.name === 'contentText') {
        return { ...acc, contentText: cur };
      } else if (cur.name === 'incidental') {
        return { ...acc, incidental: cur };
      } else if (cur.name === 'recontact') {
        return { ...acc, recontact: cur };
      }
      throw 'Unknown component';
    }, {});
  };

  mapDocumentAttachments = () => {
    let { documentContentData } = this.props;
    return documentContentData.attachments;
  };

  renderForm() {
    let { edit } = this.props;

    let documentContentComponents = this.mapDocumentContentComponents();

    return (
      <>
        <h2>{documentContentComponents.header.content.text}</h2>
        {documentContentComponents.contentText.content.text
          .split('\n')
          .map((row, i) => (
            <p key={i}>{row}</p>
          ))}
        <div style={{ padding: '20px' }} className={'ot-form'}>
          <p>
            <b>
              <FormattedMessage
                id={'biobank.agreement.part2.additional.consent'}
              />
            </b>
          </p>

          {[
            documentContentComponents.incidental,
            documentContentComponents.recontact,
          ].map((choice) => {
            return (
              <fieldset key={choice.name}>
                <legend>
                  <span className={'required'}>{choice.content.question}</span>
                </legend>
                {choice.content.options.map((option) => {
                  let id = `${choice.name}-option-${option}`;
                  return (
                    <div className="radio-block" key={id}>
                      <label>
                        <input
                          type="radio"
                          value={option}
                          disabled={!edit}
                          checked={this.state[choice.name].value === option}
                          onChange={(event) => {
                            this.setOption(choice.name, event.target.value);
                          }}
                        />
                        <span className="radio-check" />
                        <span className="radio-label">
                          <FormattedMessage
                            id={`${module_id}.option.${option}`}
                          />
                        </span>
                      </label>
                    </div>
                  );
                })}
              </fieldset>
            );
          })}
        </div>
        <div>{this.renderErrors()}</div>
      </>
    );
  }

  renderInformation() {
    return (
      <>
        <Row>
          <Span>
            <p>
              <FormattedMessage id="biobank.agreement.part2.aknowledgement.information.request" />
            </p>
          </Span>
        </Row>
        <Row>
          <Span len={4}>
            <b>
              <FormattedMessage id="biobank.agreement.part2.request.contact.information.title" />
            </b>
          </Span>
          <Span len={8}>
            <FormattedMessage
              id="biobank.agreement.part2.request.contact.information.list"
              values={{
                ul: (chunks) => <ul>{chunks}</ul>,
                li: (chunks) => <li>{chunks}</li>,
              }}
            />
          </Span>
        </Row>
      </>
    );
  }

  allowSave() {
    let { agreement } = this.props;
    let { incidental, recontact, clicked } = this.state;

    let eitherOptionModified =
      incidental.value !== incidental.original ||
      recontact.value !== recontact.original;

    let isValid =
      (incidental.value === 'YES' || incidental.value === 'NO') &&
      (recontact.value === 'YES' || recontact.value === 'NO');

    return agreement && eitherOptionModified && isValid && !clicked;
  }

  renderButtons() {
    let { edit, back, startEdit, printPdf } = this.props;
    return (
      <>
        <Row>
          <Span len={6}>
            <OTButtonGroup type={'big'} expectedCount={2} collapseOnMobile>
              <OTButton className="ot-button--gray" key="submit" onClick={back}>
                <FormattedMessage id={`back`} />
              </OTButton>
              {edit ? (
                <OTButton
                  className="ot-button--light"
                  key="readmore"
                  onClick={() => {
                    this.next()
                    this.setState({ clicked: true });
                  }}
                  disabled={!this.allowSave()}
                >
                  <FormattedMessage id={`save.changes`} />
                </OTButton>
              ) : (
                <OTButton
                  className="ot-button--light"
                  key="readmore"
                  onClick={startEdit}
                >
                  <i className="icon-pencil ot-guide__icon" />
                  <span style={{ marginLeft: '10px' }}>
                    <FormattedMessage id={`make.changes`} />
                  </span>
                </OTButton>
              )}
            </OTButtonGroup>
          </Span>
          <Span len={6}>
            {!edit && (
              <div style={{ float: 'right' }}>
                <OTButtonGroup type={'big'} expectedCount={1} collapseOnMobile>
                  <OTButton
                    className="ot-button--light"
                    key="readmore"
                    onClick={printPdf}
                  >
                    <OTIcon
                      config={{ type: 'fa', name: 'fa-print', color: 'white' }}
                    />
                    <span style={{ marginLeft: '10px' }}>
                      <FormattedMessage id={`print`} />
                    </span>
                  </OTButton>
                </OTButtonGroup>
              </div>
            )}
          </Span>
        </Row>
      </>
    );
  }

  renderUpdateErrors() {
    let { error } = this.props;

    return error ? (
      <Row>
        <Span>
          <Alert message={`${module_id}.error`} />
        </Span>
      </Row>
    ) : null;
  }

  render() {
    let { userInfo, consentData } = this.props;

    let documentContentComponents = this.mapDocumentContentComponents();
    let documentAttachments = this.mapDocumentAttachments();

    return (
      <div className="biobank_agreement_content_container_part2">
        <Row>
          <Span>{this.renderForm()}</Span>
        </Row>

        {this.renderInformation()}

        {this.renderUpdateErrors()}
        <Row>
          <Span>{this.renderButtons()}</Span>
        </Row>
        <div style={{ display: 'none' }}>
          <Consent
            version={consentData.version}
            hetu={userInfo.hetu}
            date={formatDate(consentData.validFrom)}
            wholeName={userInfo.wholeName}
            address={userInfo.address}
            recontact={this.state.recontact.value}
            incidental={this.state.incidental.value}
            attachments={documentAttachments}
            headerText={documentContentComponents.header.content.text}
            contentText={documentContentComponents.contentText.content.text}
            incidentalText={
              documentContentComponents.incidental.content.question
            }
            recontactText={documentContentComponents.recontact.content.question}
          />
        </div>
      </div>
    );
  }
}
